import {
  ADD_PRODUCT,
  DECREASE_BY_ONE,
  INCREASE_BY_ONE,
  INCREASE_BY_QUANTITY,
} from "./actionType";

const initialState = [];

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRODUCT:
      return [...state, action.payload];

    case DECREASE_BY_ONE:
      return state.map((product) => {
        if (product.id === action.payload) {
          return {
            ...product,
            quantity: Number(product.quantity) - 1,
          };
        }
        return product;
      });

    case INCREASE_BY_ONE:
      return state.map((product) => {
        if (product.id === action.payload) {
          return {
            ...product,
            quantity: Number(product.quantity) + 1,
          };
        }
        return product;
      });

    case INCREASE_BY_QUANTITY:
      return state.map((product) => {
        if (product.id === action.payload.id) {
          return {
            ...product,
            quantity: action.payload.quantity,
          };
        }
        return product;
      });

    default:
      return state;
  }
};

export default productReducer;
